var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _rect, _rect2, _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSubmission(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 67,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M2.758 55.913V6.567c0-1.885 1.545-3.417 3.446-3.417h36.379c1.9 0 3.446 1.532 3.446 3.417v49.346c0 1.885-1.546 3.418-3.446 3.418H6.203c-1.9 0-3.445-1.533-3.445-3.418z",
    fill: "#291475"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M.472 54.212V4.866c0-1.885 1.545-3.417 3.445-3.417h36.38c1.9 0 3.445 1.532 3.445 3.417v49.346c0 1.885-1.545 3.418-3.446 3.418H3.917c-1.9 0-3.445-1.533-3.445-3.418z",
    fill: "#ED1B2E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.74 54.609l.002-50.136H3.467l-.002 50.134 37.276.002z",
    fill: "#FEFFFA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.322 9.94H5.442v4.374h19.88V9.94z",
    fill: "#B0B0B0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.28,
    d: "M36.256 16.5H5.442v4.374h30.814v-4.373z",
    fill: "#B0B0B0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.322 29.82H5.442v4.375h19.88V29.82z",
    fill: "#B0B0B0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.28,
    d: "M36.256 36.381H5.442v4.374h30.814v-4.374z",
    fill: "#B0B0B0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M30.06 0h-15.9c-.965 0-1.737.774-1.737 1.724v2.59c0 .958.78 1.724 1.738 1.724H30.06c.958 0 1.738-.774 1.738-1.724v-2.59c0-.95-.78-1.724-1.738-1.724z",
    fill: "#000"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M30.71.123c.053.16.076.329.076.513v2.59a1.73 1.73 0 01-1.745 1.724h-15.9c-.231 0-.455-.038-.656-.123.216.713.88 1.226 1.669 1.226h15.898c.959 0 1.739-.774 1.739-1.724V1.732a1.72 1.72 0 00-1.082-1.61z",
    fill: "#000"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M27.913 2.452H16.3a.686.686 0 01-.687-.682c0-.376.309-.682.687-.682h11.62c.378 0 .687.306.687.682a.688.688 0 01-.695.682z",
    fill: "#B0B0B0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M43.742 3.947l-.008 51.192c0 1.38-1.12 2.49-2.51 2.49H2.981c-1.382 0-2.51-1.118-2.51-2.49v-1.992l36.108.008c1.391 0 2.511-1.119 2.511-2.498L39.1 1.449h2.132a2.507 2.507 0 012.51 2.498z",
    fill: "#291475"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.19,
    x: 27.737,
    y: 34.923,
    width: 29.821,
    height: 29.821,
    rx: 6,
    transform: "rotate(-.09 27.737 34.923)",
    fill: "#1B365D"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 25.677,
    y: 32.87,
    width: 29.821,
    height: 29.821,
    rx: 6,
    transform: "rotate(-.09 25.677 32.87)",
    fill: "#ED1B2E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#submission_svg__clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M39.374 56.397l-6.847-6.826a1.052 1.052 0 01-.002-1.487l1.485-1.49a1.052 1.052 0 011.487-.002l4.612 4.598 9.848-9.879a1.052 1.052 0 011.488-.002l1.49 1.485c.41.41.412 1.076.002 1.487L40.86 56.395a1.052 1.052 0 01-1.487.002z",
    fill: "#291475"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.127 53.583l-6.615-6.594a1.016 1.016 0 01-.002-1.437l1.435-1.44a1.016 1.016 0 011.437-.002l4.456 4.442 9.514-9.544a1.016 1.016 0 011.437-.002l1.439 1.435c.397.396.398 1.04.002 1.437L40.564 53.58a1.016 1.016 0 01-1.437.002z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "submission_svg__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "rotate(-.089 23799.04 -19809.104)",
    d: "M0 0h22.685v22.273H0z"
  })))));
}

export default SvgSubmission;